import { render } from "./DiscussionInteractive.vue?vue&type=template&id=539624b7&scoped=true"
import script from "./DiscussionInteractive.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionInteractive.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionInteractive.vue?vue&type=style&index=0&id=539624b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539624b7"]])

export default __exports__